// Single source of truth for NAP (Name / Address / Phone) and other business
// facts that get emitted into meta tags and structured data. Keep this in sync
// with the Google Business Profile — inconsistent NAP data hurts local ranking.

export const SITE_URL = "https://www.qualiteeth.co.in";

export const BUSINESS = {
  name: "Qualiteeth Dental Care",
  legalName: "Qualiteeth Dental Care",
  description:
    "Qualiteeth Dental Care is a dental clinic in Vaishali Nagar, Jaipur led by Dr. Aishwarya Sarda (MDS, Conservative Dentistry & Endodontics), offering root canal treatment, dental implants, braces and aligners, crowns and bridges, dentures, kids dentistry and general dental care.",
  telephone: "+91-92564-91206",
  // Human-readable version used in the UI / tel: links
  phoneDisplay: "(+91) 92564 91206",
  phoneHref: "tel:+919256491206",
  email: "",
  priceRange: "₹₹",
  address: {
    street: "Akruti Apartments, Mahant Swami Marg",
    locality: "Vaishali Nagar",
    region: "Rajasthan",
    postalCode: "302021",
    country: "IN",
    // Full one-line form, used in meta tags
    full: "Akruti Apartments, Mahant Swami Marg, Vaishali Nagar, Jaipur, Rajasthan 302021, India",
  },
  city: "Jaipur",
  geo: { latitude: 26.901806, longitude: 75.7392645 },
  mapUrl:
    "https://www.google.com/maps/place/Qualiteeth+Dental+Care/@26.9018108,75.7366896,17z/data=!4m6!3m5!1s0x396db52aa8fff4cf:0xfd055fea55b4585d!8m2!3d26.901806!4d75.7392645",
  reviewUrl:
    "https://search.google.com/local/writereview?placeid=ChIJz_T_qCq1bTkRXVi0VepfBf0",
  sameAs: [
    "https://www.facebook.com/share/14wSXppc43/?mibextid=wwXIfr",
    "https://www.instagram.com/qualiteeth_dental/",
    "https://www.linkedin.com/company/qualiteeth/",
  ],
  // Mirrors what the Visit section already tells patients on the homepage
  // ("Visit Us Anytime Between 10 AM – 8 PM"). If the clinic is closed or on
  // reduced hours any day of the week, split this entry — Google will surface
  // these hours in the local pack, so they must match reality.
  openingHours: [
    {
      days: [
        "Monday",
        "Tuesday",
        "Wednesday",
        "Thursday",
        "Friday",
        "Saturday",
        "Sunday",
      ],
      opens: "10:00",
      closes: "20:00",
    },
  ],
  areaServed: [
    "Jaipur",
    "Vaishali Nagar",
    "Mansarovar",
    "Ajmer Road",
    "Jhotwara",
    "Rajasthan",
  ],
};

export const DENTIST = {
  name: "Dr. Aishwarya Sarda",
  jobTitle: "Dentist, Conservative Dentistry & Endodontics",
  qualification: "MDS (Conservative Dentistry and Endodontics)",
  description:
    "Dr. Aishwarya Sarda is an MDS in Conservative Dentistry and Endodontics with 8+ years of clinical experience and the founder of Qualiteeth Dental Care, Vaishali Nagar, Jaipur.",
};

export const DEFAULT_TITLE =
  "Qualiteeth Dental Care | Best Dentist in Jaipur | Root Canal Specialist";

export const DEFAULT_DESCRIPTION =
  "Qualiteeth Dental Care is a leading dental clinic in Vaishali Nagar, Jaipur offering painless root canal treatment, dental implants, braces, crowns and teeth cleaning. Led by Dr. Aishwarya Sarda, MDS. Book an appointment today.";

// Absolute URL of the default social-share image.
export const DEFAULT_OG_IMAGE = `${SITE_URL}/og-image.jpg`;

/** Turn a route path into an absolute, canonical URL. */
export function absoluteUrl(pathname = "/") {
  if (!pathname) return SITE_URL;
  if (/^https?:\/\//i.test(pathname)) return pathname;
  const clean = pathname.startsWith("/") ? pathname : `/${pathname}`;
  // Canonical form: no trailing slash except on the homepage.
  const trimmed = clean.length > 1 ? clean.replace(/\/+$/, "") : clean;
  return `${SITE_URL}${trimmed}`;
}
